export default __webpack_public_path__ + "static/media/Slonne.8129005f.png";